import React from 'react'
import { MenuInterface } from 'src/shared/types/entities/menu'
import { CommonMenuSettings } from './common-menu-settings'

export interface MenuSettingsProps {
  entity: MenuInterface
  defaultEntity?: MenuInterface
}

export const MenuSettings = ({ entity, defaultEntity }: MenuSettingsProps) => {
  return <CommonMenuSettings entity={entity} defaultEntity={defaultEntity} />
}
